import { RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
const EMPTY_STATUS_ACTIONS_CONSTANTS = {
    MAIN_BUTTON_PROPS: {
        size: RELOADED_VARIANTS.ButtonSizeType.LARGE,
        type: RELOADED_VARIANTS.ButtonVariantType.PRIMARY,
    },
    SECONDARY_BUTTON_PROPS: {
        size: RELOADED_VARIANTS.ButtonSizeType.LARGE,
        type: RELOADED_VARIANTS.ButtonVariantType.SECONDARY,
    },
};
export { EMPTY_STATUS_ACTIONS_CONSTANTS };
//# sourceMappingURL=empty-status-actions.constants.js.map